export const acaoConstantes = {
  ADICIONAR: 0,
  EDITAR: 1
}
